(function (global) {
  'use strict';

  var ROOT_SELECTOR = '[data-qy-upcoming-observance]';
  var controllers = typeof WeakMap === 'function' ? new WeakMap() : null;

  if (global.QiyuanUpcomingObservance && global.QiyuanUpcomingObservance.version === '2.0.0') {
    if (global.document) global.QiyuanUpcomingObservance.init(global.document);
    return;
  }

  function query(scope, selector) {
    return scope && scope.querySelector ? scope.querySelector(selector) : null;
  }

  function queryAll(scope, selector) {
    return scope && scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : [];
  }

  function matches(element, selector) {
    return Boolean(element && element.matches && element.matches(selector));
  }

  function rootsWithin(scope) {
    var roots = [];
    if (matches(scope, ROOT_SELECTOR)) roots.push(scope);
    queryAll(scope, ROOT_SELECTOR).forEach(function (root) {
      if (roots.indexOf(root) === -1) roots.push(root);
    });
    return roots;
  }

  function setText(root, selector, value) {
    var element = query(root, selector);
    if (element) element.textContent = value || '';
  }

  function setLink(root, selector, label, href) {
    var link = query(root, selector);
    if (!link) return;
    link.textContent = label || '';
    link.setAttribute('href', href || '/');
  }

  function renderEvent(root, event, calendar, now) {
    var card = query(root, '[data-qy-observance-current]');
    var fallback = query(root, '[data-qy-observance-fallback]');
    if (!card || !fallback) return null;

    if (!event || !calendar.validEvent(event)) {
      card.hidden = true;
      fallback.hidden = false;
      root.removeAttribute('data-active-observance');
      return null;
    }

    var todayKey = calendar.getTodayKey(now, calendar.timeZone);
    var status = calendar.statusFor(event, todayKey);
    var dateText = calendar.formatDate(event.date);
    var statusText = status === 'Today' ? 'TODAY · ' + dateText : 'UPCOMING · ' + dateText;

    setText(root, '[data-qy-observance-status]', statusText);
    setText(root, '[data-qy-observance-title]', event.englishTitle);
    setText(root, '[data-qy-observance-title-zh]', event.chineseTitle);
    setText(root, '[data-qy-observance-lunar]', event.lunarNote);
    setText(root, '[data-qy-observance-intro]', event.introduction);
    setLink(root, '[data-qy-observance-primary]', event.primaryCtaLabel, event.primaryCtaUrl);
    setLink(root, '[data-qy-observance-secondary]', event.secondaryCtaLabel, event.secondaryCtaUrl);

    var time = query(root, '[data-qy-observance-time]');
    if (time) time.setAttribute('datetime', event.date);

    var image = query(root, '[data-qy-observance-image]');
    var source = query(root, '[data-qy-observance-source]');
    calendar.syncImage(root, event, image, source);

    fallback.hidden = true;
    card.hidden = false;
    root.setAttribute('data-active-observance', event.id);
    return event;
  }

  function Controller(root, options) {
    this.root = root;
    this.options = options || {};
    this.document = this.options.document || global.document;
    this.window = this.options.window || global;
    this.getNow = this.options.getNow || function () { return new Date(); };
    this.setInterval = this.options.setInterval || this.window.setInterval.bind(this.window);
    this.clearInterval = this.options.clearInterval || this.window.clearInterval.bind(this.window);
    this.timer = null;
    this.connected = false;
    this.onPageShow = this.refresh.bind(this);
    this.onVisibility = this.handleVisibility.bind(this);
  }

  Controller.prototype.refresh = function () {
    var calendar = global.QiyuanObservanceCalendar;
    if (!this.connected || !calendar) return null;
    var now = this.getNow();
    return renderEvent(this.root, calendar.selectNextEvent(calendar.events, {
      now: now,
      timeZone: calendar.timeZone,
    }), calendar, now);
  };

  Controller.prototype.handleVisibility = function () {
    if (!this.document || this.document.visibilityState !== 'hidden') this.refresh();
  };

  Controller.prototype.connect = function () {
    if (this.connected) return this;
    this.connected = true;
    if (this.document && this.document.addEventListener) {
      this.document.addEventListener('visibilitychange', this.onVisibility);
    }
    if (this.window && this.window.addEventListener) this.window.addEventListener('pageshow', this.onPageShow);
    this.timer = this.setInterval(this.refresh.bind(this), 60000);
    this.refresh();
    return this;
  };

  Controller.prototype.disconnect = function () {
    if (!this.connected) return;
    this.connected = false;
    if (this.timer !== null) this.clearInterval(this.timer);
    this.timer = null;
    if (this.document && this.document.removeEventListener) {
      this.document.removeEventListener('visibilitychange', this.onVisibility);
    }
    if (this.window && this.window.removeEventListener) this.window.removeEventListener('pageshow', this.onPageShow);
  };

  function getController(root) {
    return controllers ? controllers.get(root) : root.__qyUpcomingObservanceController;
  }

  function setController(root, controller) {
    if (controllers) controllers.set(root, controller);
    else root.__qyUpcomingObservanceController = controller;
  }

  function init(scope, options) {
    return rootsWithin(scope || global.document).map(function (root) {
      var controller = getController(root);
      if (!controller) {
        controller = new Controller(root, options);
        setController(root, controller);
      }
      return controller.connect();
    });
  }

  function disconnect(scope) {
    rootsWithin(scope).forEach(function (root) {
      var controller = getController(root);
      if (controller) controller.disconnect();
      if (controllers) controllers.delete(root);
      else delete root.__qyUpcomingObservanceController;
    });
  }

  var api = {
    version: '2.0.0',
    renderEvent: renderEvent,
    Controller: Controller,
    init: init,
    disconnect: disconnect,
    getController: getController,
  };
  global.QiyuanUpcomingObservance = api;

  if (global.customElements && global.HTMLElement && !global.customElements.get('qiyuan-upcoming-observance')) {
    var Element = function () { return Reflect.construct(global.HTMLElement, [], Element); };
    Element.prototype = Object.create(global.HTMLElement.prototype);
    Element.prototype.constructor = Element;
    Object.setPrototypeOf(Element, global.HTMLElement);
    Element.prototype.connectedCallback = function () { init(this); };
    Element.prototype.disconnectedCallback = function () { disconnect(this); };
    global.customElements.define('qiyuan-upcoming-observance', Element);
  }

  if (global.document && global.document.addEventListener) {
    global.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    global.document.addEventListener('shopify:section:unload', function (event) { disconnect(event.target); });
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { init(global.document); }, { once: true });
    } else {
      init(global.document);
    }
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);
